export const reconstructMessage = chunkedMessages => {
    const firstChunk = chunkedMessages[0];
    if (firstChunk) {
        const messagePayload = [...chunkedMessages]
            .sort((a, b) => a.batchSequence - b.batchSequence)
            .reduce((prev, curr) => prev + curr.payload, '');
        return {
            payload: JSON.parse(messagePayload),
            sequence: firstChunk.sequence,
            sequenceStartTime: firstChunk.sequenceStartTime,
        };
    }
};
//# sourceMappingURL=reconstruct-batched-message.js.map